import {
    Button,
    Grid,
    InputAdornment,
    Paper,
    TextField
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from '@mui/icons-material/LocationOnOutlined';

interface SearchAndFilterSectionProps {
    searchQuery: string;
    setSearchQuery: (query: string) => void;
    location: string;
    setLocation: (location: string) => void;
}

export const SearchAndFilterSection = ({ searchQuery, setSearchQuery, location, setLocation }: SearchAndFilterSectionProps) => (
    <Paper sx={{ p: 2, mb: 3, bgcolor: "background.paper" }}>
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={5}>
                <TextField
                    fullWidth
                    placeholder="Search by name or email"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    size="small"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={12} md={5}>
                <TextField
                    fullWidth
                    placeholder="Filter by location"
                    size="small"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <LocationOnIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={12} md={2}>
                <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    size="small"
                    sx={{ backgroundColor: 'primary.main', height: 1 }}
                >
                    SEARCH
                </Button>
            </Grid>
        </Grid>
    </Paper>
);